<script lang="ts" setup>
import ErrorCodes from "~/widgets/service/errorCodes.vue";
import getSeoData from '~/composables/seo-data'
import type { ISeoOptions } from '~/shared/interfaces/seo'
import { useConfigStore } from '~/shared/store/modules/config'

const configStore = useConfigStore()
const route = useRoute()
let dataSeo = ref<ISeoOptions>()
watch(
  () => route.fullPath,
  async () => {
    const currentURL = useRequestURL()
    const seoUrl = configStore.config?.apiBaseUrl
      ? configStore.config.apiBaseUrl.replace('/v1', route.path)
      : currentURL.href
    dataSeo.value = await getSeoData(seoUrl)
  },
  { immediate: true }
)
</script>

<template>
  <div class="error">
    <NuxtLayout name="service">
      <ErrorCodes/>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
:deep(.main) {
  background-color: $bg_page;
}

.error{
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  display: flex;
  flex-direction: column;
}

.service{
  height: 100%;
  margin-top: 80px;
  display: flex;
  justify-content: center;
  @include sm-breakpoint{
    flex-direction: column;
    gap: 28px;
    align-items: center;
  }

  &__code{
    color: $control-content_primary;
    @include font(24px, 28px, 500);
    background-color: $bg_neutral;
    border-radius: 100px;
    padding: 6px 12px;
    width: fit-content;
    @include sm-breakpoint{
      @include font(20px, 24px, 500)
    }
  }

  &__title{
    margin-top: 8px;
    @include font(36px, 44px, 700);
    @include sm-breakpoint{
      @include font(28px, 32px, 600)
    }
  }

  &__subtitle{
    margin-top: 12px;
    @include font(16px, 20px, 400);
  }

  &__link{
    margin-top: 28px;
    @include sm-breakpoint{
      width: 100%;
    }
  }
}
</style>
